import { render, staticRenderFns } from "./BDD.vue?vue&type=template&id=5b492d15&scoped=true&"
import script from "./BDD.vue?vue&type=script&lang=js&"
export * from "./BDD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b492d15",
  null
  
)

export default component.exports